import { render, staticRenderFns } from "./SingleWidgetInFourWidgetsSection.vue?vue&type=template&id=50c751ab&"
import script from "./SingleWidgetInFourWidgetsSection.vue?vue&type=script&lang=js&"
export * from "./SingleWidgetInFourWidgetsSection.vue?vue&type=script&lang=js&"
import style0 from "./SingleWidgetInFourWidgetsSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SingleWidgetInFourWidgetsSection.vue"
export default component.exports